import api from 'api'
import { CACHE_TAG_CONTACT_VERSION_LIST, CACHE_TAG_CONTACT_VERSION_REFS } from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    delecteContact: build.mutation({
      query: ({ accountId, contactId }) => ({ url: `/api/v1/core/accounts/${accountId}/contacts/${contactId}`, method: 'DELETE' }),
      invalidatesTags: (result, error, arg) => {
        const tags = []
        const accountId = arg?.accountId || result?.accountId
        const contactId = arg?.contactId || result?.id
        if (accountId) tags.push({ type: CACHE_TAG_CONTACT_VERSION_REFS, id: accountId })
        if (contactId) tags.push({ type: CACHE_TAG_CONTACT_VERSION_LIST, id: contactId })
        return tags
      },
    }),
  }),
})

export const { useDelecteContactMutation } = extendedApi
